module.exports = __webpack_public_path__ + "img/logo-icon-app.3f1ac258.png";